
import { InjectionToken } from '@angular/core';
import type { Request, Response } from 'express';

export interface ExpressRequestContext {
  request: Request;
  response: Response;
}

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');
